// ═══════════════════════════════════════════════════════════════
// MoodConfig.js — Mood emoji, label, and color definitions
// Adapted from MoodComponents.jsx patterns.
// ═══════════════════════════════════════════════════════════════

const MOOD_EMOJIS = { 1: '😞', 2: '😕', 3: '😐', 4: '😊', 5: '😄' };
const MOOD_LABELS = { 1: 'Not awesome', 2: 'Could be better', 3: 'Okay', 4: 'Pretty good', 5: 'Great!' };
const MOOD_COLORS = {
  1: 'bg-red-100 text-red-700 border-red-200',
  2: 'bg-orange-100 text-orange-700 border-orange-200',
  3: 'bg-amber-100 text-amber-700 border-amber-200',
  4: 'bg-green-100 text-green-700 border-green-200',
  5: 'bg-emerald-100 text-emerald-700 border-emerald-200',
};
const MOOD_BAR_COLORS = { 1: 'bg-red-400', 2: 'bg-orange-400', 3: 'bg-amber-400', 4: 'bg-green-400', 5: 'bg-emerald-400' };

const MOOD_OPTIONS = [
  { rating: 1, emoji: '😞', label: 'Not awesome at all', color: 'from-red-600 to-red-700', bg: 'bg-red-50 border-red-200 hover:border-red-400', activeBg: 'bg-red-100 border-red-500 ring-2 ring-red-300' },
  { rating: 2, emoji: '😕', label: 'Could be better', color: 'from-orange-700 to-orange-800', bg: 'bg-orange-50 border-orange-200 hover:border-orange-400', activeBg: 'bg-orange-100 border-orange-500 ring-2 ring-orange-300' },
  { rating: 3, emoji: '😐', label: 'Doing okay', color: 'from-amber-700 to-yellow-700', bg: 'bg-amber-50 border-amber-200 hover:border-amber-400', activeBg: 'bg-amber-100 border-amber-500 ring-2 ring-amber-300' },
  { rating: 4, emoji: '😊', label: 'Pretty good', color: 'from-lime-700 to-green-700', bg: 'bg-green-50 border-green-200 hover:border-green-400', activeBg: 'bg-green-100 border-green-500 ring-2 ring-green-300' },
  { rating: 5, emoji: '😄', label: 'Great!', color: 'from-emerald-700 to-teal-700', bg: 'bg-emerald-50 border-emerald-200 hover:border-emerald-400', activeBg: 'bg-emerald-100 border-emerald-500 ring-2 ring-emerald-300' },
];

const CONTRIBUTING_FACTORS = [
  'Work',
  'Family',
  'Health',
  'Sleep',
  'Finances',
  'Relationships',
  'Weather',
  'Other',
];

export {
  MOOD_EMOJIS,
  MOOD_LABELS,
  MOOD_COLORS,
  MOOD_BAR_COLORS,
  MOOD_OPTIONS,
  CONTRIBUTING_FACTORS,
};
